module.exports = __webpack_public_path__ + "static/media/tit_2.81528368.png";